window.initTrainingItemQuestionForm = function() {
  initFormSort();
  $(document).on('change', '.js-correct', function(){
    if($(this).is(':checked')){
      $('.js-correct').not(this).prop('checked', false);
    } else {
      $(this).prop('checked', true);
    }
  })
}